import { z } from 'zod';
import i18n from '@/shared/i18n';

export const createWorkspaceSchema = z.object({
  workspaceName: z
    .string()
    .min(1, i18n.t('workspace.create.error.nameRequired', { ns: 'workspace' })),
  workspaceIcon: z.string(),
  workspaceColor: z.string(),
  // No min length — an empty value means "not specified". Only the Finance
  // option carries behaviour (it makes the workspace finance-typed), so leaving
  // the purpose unpicked must not block creation, same as the equivalent domain
  // picker in onboarding.
  workspacePurpose: z.string(),
});

export type CreateWorkspaceFormData = z.infer<typeof createWorkspaceSchema>;
